import React, {Component} from 'react'
import styled, { css } from 'styled-components'
import { rgba } from 'polished'

import { media } from '../../styles/utils'


class InputText extends Component {

    render() {


        return (
            <Wrapper>
                <Input
                    className={this.props.className}
                    type="text"
                    name={this.props.name}
                    placeholder={this.props.placeholder}
                    value={this.props.value}
                    onBlur={this.props.onBlur}
                    onChange={this.props.onChangeValue}
                    error={this.props.error && this.props.showErrors}
                    required
                />
                {this.props.showErrors && this.props.error  && (
                    <Error
                        className={'error'}
                    >
                        {this.props.errorMessage}
                    </Error>
                )}
            </Wrapper>
        )
    }
}

export const Wrapper = styled.div`
    width: 100%;
`

export const Error = styled.div`
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    padding-top: 8px;
    


`
export const Input = styled.input`
    appearance: none;
    box-shadow: none;
    display: flex;
    flex: 1;
    height: 52px;   
    width: 100%;
    transition: border 0.20s ease;
    border: none;
    padding-left: 15px;
    box-sizing: border-box;
    background: white;

    ${media.tablet`
       
    `}

    &, &::placeholder {
        font-size: 17px;
        line-height: 1.24;
    }

    &:focus {
        outline: none;
    }

    &::placeholder {
        /* opacity: 0.3; */
    }

    &, &::placeholder {
        font-family: 'Scto';
        font-size: 18px;
        color: rgba(89,88,80,0.50)!important;
        letter-spacing: 0;
        line-height: 18px;
        text-align: center;
    }

    ${props => {
       
        if (props.shakeOnError && props.error) {

            return css`

                /* animation: shakin 0.4s 1 linear;
                @keyframes shakin {
                    0% { -webkit-transform: translate(30px); }
                    20% { -webkit-transform: translate(-30px); }
                    40% { -webkit-transform: translate(15px); }
                    60% { -webkit-transform: translate(-15px); }
                    80% { -webkit-transform: translate(8px); }
                    100% { -webkit-transform: translate(0px); }
                } */

                /* &, &::placeholder {
                    color: red;
                } */
            `
        }
    }}
`

export default InputText;



// WEBPACK FOOTER //
// ./src/components/InputText/InputText.js